module.exports = __webpack_public_path__ + "static/media/Node.85458a67.png";